var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"carousel"},[(_vm.bannerImages)?_c('div',[_c('VueSlickCarousel',{attrs:{"arrows":true,"fade":true,"autoplaySpeed":7000,"speed":800,"autoplay":true,"lazyLoad":"ondemand"}},_vm._l((_vm.bannerImages),function(i,index){return _c('div',{key:index},[_c('img',{attrs:{"alt":"","src":i.url_image}})])}),0)],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }